import { LocaleInput } from '../index.js'

export default {
  code: 'zh-tw',
  buttonText: {
    prev: '上月',
    next: '下月',
    today: '今天',
    month: '月',
    week: '週',
    day: '天',
    list: '活動列表',
  },
  weekText: '周',
  allDayText: '整天',
  moreLinkText: '顯示更多',
  noEventsText: '没有任何活動',
} as LocaleInput
